import { AnyAction } from 'redux';
import { DefaultMapping, SupplierMapping, Unit } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';

import {
    CANCEL_CREATE_UNIT,
    CANCEL_DELETE_UNIT,
    CANCEL_PATCH_UNIT,
    CANCEL_UPDATE_UNIT_MAPPING,
    CREATE_UNIT_COMPLETED,
    DELETE_UNIT_COMPLETED,
    PATCH_UNIT_COMPLETED,
    RECEIVE_ALL_UNITS,
    RECEIVE_UNITS,
    RECEIVE_UNIT_DEFAULT_MAPPING,
    RECEIVE_UNIT_DEFAULT_MAPPINGS,
    REQUEST_ALL_UNITS,
    REQUEST_UNITS,
    START_CREATE_UNIT,
    START_DELETE_UNIT,
    START_PATCH_UNIT,
    START_UPDATE_UNIT_MAPPING,
} from '../actions/unit-actions';

export interface UnitReducerState {
    allUnits: Unit[];
    units: PaginatedResponse<Unit>;
    defaultMappings: PaginatedResponse<DefaultMapping<Unit>>;
    supplierMappings: PaginatedResponse<SupplierMapping<Unit>>;
    requesting: boolean;
}

const initialUnitsReducerState: UnitReducerState = {
    allUnits: [],
    units: { items: [], limit: 10, page: 0, total: 0 },
    defaultMappings: { items: [], limit: 10, page: 0, total: 0 },
    supplierMappings: { items: [], limit: 10, page: 0, total: 0 },
    requesting: false,
};

export const unitReducer = (
    state: UnitReducerState = initialUnitsReducerState,
    action: AnyAction
): UnitReducerState => {
    const { type, ...rest } = action;

    switch (type) {
        case START_UPDATE_UNIT_MAPPING:
        case REQUEST_UNITS:
        case REQUEST_ALL_UNITS:
        case START_PATCH_UNIT:
        case START_CREATE_UNIT:
        case START_DELETE_UNIT: {
            return {
                ...state,
                requesting: true,
            };
        }

        case CANCEL_UPDATE_UNIT_MAPPING:
        case CANCEL_CREATE_UNIT:
        case CANCEL_PATCH_UNIT:
        case CANCEL_DELETE_UNIT: {
            return {
                ...state,
                requesting: false,
            };
        }

        case RECEIVE_UNITS: {
            return {
                ...state,
                units: rest['paginatedUnits'],
                requesting: false,
            };
        }

        case RECEIVE_UNIT_DEFAULT_MAPPING: {
            const items = [...state.defaultMappings.items];
            const index = items.findIndex(mapping => mapping.id === rest['defaultMapping'].id);
            if (index >= 0) {
                items[index] = rest['defaultMapping'];
            }

            return {
                ...state,
                defaultMappings: { ...state.defaultMappings, items },
                requesting: false,
            };
        }

        case RECEIVE_UNIT_DEFAULT_MAPPINGS: {
            return {
                ...state,
                defaultMappings: rest['defaultMappings'],
                requesting: false,
            };
        }

        case CREATE_UNIT_COMPLETED: {
            return {
                ...state,
                units: {
                    ...state.units,
                    items: [...state.units.items, rest['unit']],
                },
                requesting: false,
            };
        }

        case DELETE_UNIT_COMPLETED: {
            return {
                ...state,
                units: {
                    ...state.units,
                    items: state.units.items.filter(item => item.id !== rest['unitId']),
                },
                requesting: false,
            };
        }

        case PATCH_UNIT_COMPLETED: {
            const items = [...state.units.items];
            const index = items.findIndex(item => item.id === rest['unit'].id);
            if (index >= 0) {
                items[index] = rest['unit'];
            }

            return {
                ...state,
                units: {
                    ...state.units,
                    items,
                },
                requesting: false,
            };
        }
        case RECEIVE_ALL_UNITS: {
            return {
                ...state,
                allUnits: rest['units'],
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
